import { clubImageUrl } from "../../../../utils/ClubUtils";
import "./ClubPartner.css";

// Miniatura da logo; sem arte, a inicial do parceiro na cor da marca, como a vitrine mostra.
const logoRenderer = (params) => {
    const partner = params.data;
    if (!partner) return null;
    const src = clubImageUrl(partner.logoPath);
    return src
        ? <img src={src} alt="" className="club-grid-logo" />
        : <span className="club-grid-logo club-grid-logo--initial" style={{ background: partner.brandColor || '#fb6a21' }}>
            {(partner.name || '?').charAt(0).toUpperCase()}
        </span>;
};

const nameRenderer = (params) => (params.data
    ? <span>
        {params.data.name}
        {params.data.featured && <span className="club-grid-badge ms-2">Destaque</span>}
    </span>
    : null);

// Só as ofertas que estão valendo; as retiradas continuam no cadastro para o histórico.
const offersRenderer = (params) => (params.data?.offers || []).filter((offer) => offer.status === 'ACTIVE').length;

const accessRenderer = (params) => (params.data?.accessConfigured
    ? <span className="club-grid-flag club-grid-flag--ok">Liberado</span>
    : <span className="club-grid-flag">Sem PIN</span>);

// A ordem vem do servidor; nenhuma coluna ordena.
export const makeColumns = (onAccess) => [
    { headerName: 'Parceiro', field: 'name', cellRenderer: (params) => params.data && <span className="club-grid-partner">{logoRenderer(params)}<span className="club-grid-partner__name">{nameRenderer(params)}</span></span>, sortable: false, width: 260 },
    { headerName: 'category', field: 'category', sortable: false, width: 160 },
    // Cidade do endereço cadastrado; o parceiro sem endereço fica em branco.
    { headerName: 'address.city', valueGetter: (params) => params.data?.address?.city || '-', sortable: false, width: 150 },
    { headerName: 'Ofertas', field: 'offers', cellRenderer: offersRenderer, sortable: false, width: 100 },
    { headerName: 'Cupons gerados', field: 'couponsGenerated', sortable: false, width: 150 },
    { headerName: 'Cupons usados', field: 'couponsUsed', sortable: false, width: 130 },
    { headerName: 'Acesso', field: 'accessConfigured', cellRenderer: (params) => params.data && <span className="club-grid-access">{accessRenderer(params)}<button type="button" className="club-grid-access__button" onClick={(event) => { event.stopPropagation(); onAccess(params.data); }}>Ver acesso</button></span>, sortable: false, width: 210 }
];
